import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-b-2 flex flex-row justify-between items-center pb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-base font-semibold" }, [
    /*#__PURE__*/_createTextVNode(" Work experience "),
    /*#__PURE__*/_createElementVNode("strong", { class: "text-base font-thin text-gray-300" }, "(Optional)")
  ])
], -1)
const _hoisted_2 = { class: "w-full flex flex-row justify-between items-centers" }
const _hoisted_3 = { class: "flex flex-row space-x-5 items-center" }
const _hoisted_4 = { class: "w-52" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl" }, "-", -1)
const _hoisted_6 = {
  key: 0,
  class: "w-52"
}
const _hoisted_7 = { class: "flex flex-row items-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-white",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add experience", -1)
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-red-500 ml-2" }, "Clear", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "flex flex-row space-x-12 w-full" }
const _hoisted_17 = { class: "w-1/3" }
const _hoisted_18 = { class: "w-1/3" }
const _hoisted_19 = { class: "w-1/3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-200" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDatePicker = _resolveComponent("CustomDatePicker")!
  const _component_RenderCheckBox = _resolveComponent("RenderCheckBox")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_FieldArray = _resolveComponent("FieldArray")!

  return (_openBlock(), _createBlock(_component_FieldArray, { name: "candidate_work_histories" }, {
    default: _withCtx(({ fields, push, remove }) => [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "space-y-4 mt-6",
          key: field.key
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_CustomDatePicker, {
                  placeholder: "Start date",
                  name: `candidate_work_histories[${idx}].start_date`
                }, null, 8, ["name"])
              ]),
              _hoisted_5,
              (!field.value.is_current)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_CustomDatePicker, {
                      placeholder: "End date",
                      name: `candidate_work_histories[${idx}].end_date`
                    }, null, 8, ["name"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_RenderCheckBox, {
                name: `candidate_work_histories[${idx}].is_current`,
                value: false,
                label: "Current"
              }, null, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (field.value.job_title !== '' && field.isLast === true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "mr-4 flex flex-row items-center btn-text",
                    type: "button",
                    onClick: ($event: any) => (
              push({
                start_date: null,
                end_date: null,
                job_title: '',
                company: '',
                is_current: false,
              })
            )
                  }, [
                    _createElementVNode("div", {
                      class: "w-6 h-6 flex flex-col justify-center items-center rounded-full",
                      style: _normalizeStyle({
                'background-color': `${_ctx.hexToRGBA(_ctx.primaryColor, 1)}`,
              })
                    }, _hoisted_10, 4),
                    _hoisted_11
                  ], 8, _hoisted_8))
                : _createCommentVNode("", true),
              (fields.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "flex flex-row items-center",
                    type: "button",
                    onClick: ($event: any) => (remove(idx))
                  }, _hoisted_15, 8, _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_TextField, {
                className: "pt-5 pb-2 pl-4 text-sm pr-2 block w-full px-0 mt-0 bg-transparent border-2 rounded-full border-solid appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 border-gray-200",
                label: "",
                placeholder: "Job Title",
                name: `candidate_work_histories[${idx}].job_title`,
                board: true
              }, null, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_TextField, {
                className: "pt-5 pb-2 pl-4 pr-2 block text-sm w-full px-0 mt-0 bg-red-200 border-2 rounded-full border-solid appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 border-gray-200",
                label: "",
                placeholder: "Company Name",
                name: `candidate_work_histories[${idx}].company_name`,
                board: true
              }, null, 8, ["name"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_DropDown, {
                options: _ctx.industries,
                label: "Select industry...",
                name: `candidate_work_histories[${idx}].industry`
              }, null, 8, ["options", "name"])
            ])
          ]),
          _hoisted_20
        ]))
      }), 128))
    ]),
    _: 1
  }))
}